import endsWith from 'lodash/endsWith';

import { setCurrentCountry } from '@front/common/src/utils/country';
import { COUNTRIES_BY_DOMAIN, DEFAULT_COUNTRY } from '@front/common/src/constants/country';
import { Country } from '@front/common/src/types/commons';

import { getI18nLocale } from '@front/i18n';

// This is a specific const for web
// as each domain is binded to language and country
const WEBAPP_LOCALE_BY_COUNTRY: Record<Country, string> = {
  FR: 'fr',
  GB: 'en-gb',
};

const getCurrentDomain = () =>
  Object.keys(COUNTRIES_BY_DOMAIN).find((domain) => endsWith(window.location.hostname, domain));

const getCountryByDomain = () => {
  const domain = getCurrentDomain();
  return domain ? COUNTRIES_BY_DOMAIN[domain] : undefined;
};

export const getWebAppLocale = () =>
  WEBAPP_LOCALE_BY_COUNTRY[getCountryByDomain() || DEFAULT_COUNTRY] || getI18nLocale();

export const setCountry = () => {
  setCurrentCountry(getCountryByDomain());
};
